// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3R1m_","fileBtn":"File_fileBtn__3mGLz","closeBtn":"File_closeBtn__3qx53","fileSelected":"File_fileSelected__7wfhi","disabled":"File_disabled__12rIH"};